import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface Props {
  children: React.ReactNode;
  requiredRole?: "buyer" | "seller" | "provider" | "admin";
  requiredAccountType?: "personal" | "company" | "admin";
}

export function ProtectedRoute({ children, requiredRole, requiredAccountType }: Props) {
  const { user, loading, hasRole, profile, rolesLoaded } = useAuth();

  const stillLoading = loading || (!!user && requiredRole && !rolesLoaded);

  if (stillLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/logga-in" replace />;
  if (requiredRole && !hasRole(requiredRole)) return <Navigate to="/" replace />;
  if (requiredAccountType && profile?.account_type !== requiredAccountType) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
